import {
  FETCHED_MATCHED_PAIRS,
  FETCHED_MATCHED_ORDERS,
  FETCHED_MY_MATCHED_ORDERS,
  FETCHED_PAST_ORDERS,
  FETCHED_STATS,
  FETCHED_MY_PAST_ORDERS,
} from '../../types';

import callBC from '../../helpers/bc'
// import {getBlake} from '../../passport/get';
import {fromUnit, tokenDictionary} from '../../../config';
import {deletePending,triggerEvents} from '../../ui/marketplace';
import {lowestDenom} from '../../../config';
import {unlockData} from './unlockData';
import {Decimal} from 'decimal.js';

const { blake2bl } = require('bc-sdk/dist/utils/crypto')
const { last } = require('ramda')

async function retrieveOrders(settings,addresses) {
  let orders = [];
  for(let addr of addresses){
    let data = await callBC(settings,'getUTXOLength',['taker_output',addr])
    let sum = data.result.length;
    if(sum > 0){
      let final = sum;
      let from = 0;
      let to = final < 1000 ? final : 1000;
      let search = true;
      while(search){
        data = await callBC(settings,'getMatchedOrders',[addr,from,to])
        if(data.result && data.result.ordersList){
          orders = orders.concat(data.result.ordersList)
        }
        if(to === final) search = false;
        from = to + 1;
        to = to + 1000 > final ? final : to + 1000;
      }
    }
  }
  return orders;
}

async function retrieveHistory(settings,addresses) {
  let orders = [];
  let data = await callBC(settings,'getHistoricalOrders',['latest'])
  if(data.result && data.result.ordersList){
    orders = data.result.ordersList;
    let i = 0;
    while(data.result.nextBlock && i <= 5){
      data = await callBC(settings,'getHistoricalOrders',[data.result.nextBlock.toString(),1000])
      if(data.result && data.result.ordersList) orders = orders.concat(data.result.ordersList);
      i++;
    }
  }
  return orders;
}

export async function getMatchedOrders(history,dispatch,state){
  try {

    let orders = await retrieveOrders(state.settings.settings,Object.keys(state.passport.wallet.nrg))
    let newPairs = JSON.parse(JSON.stringify(require('../../../config').pairs))
    let {newOrders,pairs} = cleanUpMatchedOrders(newPairs,orders,state.socket.bcHeight,state.socket.timestamp)
    let my_matched = []
    let hash = {};

    newOrders.forEach(o => {
      Object.keys(state.passport.nrg).map((addr)=>{
        let blake_address = '0x'+ blake2bl(blake2bl(addr) + addr);
        if(o.maker.doubleHashedBcAddress === blake_address && !hash[o.taker.txHash+'maker']) {
          hash[o.taker.txHash+'maker'] = true;
          o.address = addr;
          my_matched.push({...o,isMaker:true})
        }
        if(o.taker.doubleHashedBcAddress === blake_address && !hash[o.taker.txHash+'taker']) {
          o.address = addr;
          hash[o.taker.txHash+'taker'] = true;
          my_matched.push({...o,isTaker:true})
        }
      })
    });

    my_matched = await cleanUpMyMatchedOrders(my_matched,state)

    dispatch({
      type:FETCHED_MY_MATCHED_ORDERS,
      payload:my_matched.filter(o=> o.past == false)
    });

    dispatch({
      type:FETCHED_MY_PAST_ORDERS,
      payload:my_matched.filter(o=> o.past)
    });


    let history = await retrieveHistory(state.settings.settings);
    let newPairs2 = JSON.parse(JSON.stringify(require('../../../config').pairs));
    let obj = cleanUpMatchedOrders(newPairs2,history,state.socket.bcHeight,state.socket.timestamp);

    dispatch({
      type:FETCHED_MATCHED_PAIRS,
      payload:obj.pairs
    })

    dispatch({
      type:FETCHED_STATS,
      payload:obj.stats
    })


    triggerEvents(my_matched,state,dispatch)

    deletePending(my_matched,state,dispatch)
  }
  catch(err){
    console.log({err})
  }
}

//HELPER FUNCTIONS
let cleanUpMatchedOrders = (pairs,orders,bcHeight,timestamp) => {
  let stats = JSON.parse(JSON.stringify(require('../../../config').pairs));
  let newOrders = orders.map(o => {
    o.taker.collateralizedNrg = o.taker.totalCollateral;
    if(o.maker.tradeHeight + o.maker.settlement - bcHeight > 0) {
      o.deadline =`in ${o.maker.tradeHeight + o.maker.settlement - bcHeight} BC Blocks `;
      if(tokenDictionary[o.maker.sendsFromChain].toUpperCase() !== 'BC') o.deadline += `+ ${o.maker.shiftMaker+1} ${tokenDictionary[o.maker.sendsFromChain].toUpperCase()} Block`;
      if(tokenDictionary[o.maker.sendsFromChain].toUpperCase() != tokenDictionary[o.maker.receivesToChain].toUpperCase()){
        o.deadline += `+ ${o.maker.shiftTaker+1} ${tokenDictionary[o.maker.receivesToChain].toUpperCase()} Blocks`
      }
    }
    else o.deadline = 'Settled';

    o.past = false;
    o.maker.receivesUnit = fromUnit(o.maker.receivesToChain,o.maker.receivesUnit)
    o.maker.sendsUnit = fromUnit(o.maker.sendsFromChain,o.maker.sendsUnit)
    o.maker.receivesUnit = new Decimal(o.maker.receivesUnit).mul((new Decimal(o.maker.collateralizedNrg).div(new Decimal(o.maker.originalNrg)))).toNumber()
    o.maker.sendsUnit = new Decimal(o.maker.sendsUnit).mul((new Decimal(o.maker.collateralizedNrg).div(new Decimal(o.maker.originalNrg)))).toNumber()

    o.txHash = o.taker.txHash
    o.txOutputIndex = o.taker.txOutputIndex;

    let divider = new Decimal(o.maker.collateralizedNrg).div((new Decimal(o.taker.collateralizedNrg).div(new Decimal(o.maker.base))));

    let index = `${o.maker.receivesToChain.toUpperCase()}/${o.maker.sendsFromChain.toUpperCase()}`;
    let index2 = `${o.maker.sendsFromChain.toUpperCase()}/${o.maker.receivesToChain.toUpperCase()}`;

    let demand = pairs['bid/ask'][index2] ? true : false;

    if(demand){
      o.price = new Decimal(o.maker.receivesUnit).div(new Decimal(o.maker.sendsUnit)).div(divider).toString();
      o.amount = new Decimal(o.maker.sendsUnit).div(divider).toString();
      o.color = `rgb(101, 173, 97)`;
    } else {
      o.price = new Decimal(o.maker.sendsUnit).div(new Decimal(o.maker.receivesUnit)).div(divider).toString();
      o.amount = new Decimal(o.maker.receivesUnit).div(divider).toString();
      o.color = `rgb(222, 114, 114)`;
    }

    o.timestamp = new Date((timestamp*1000) - ((bcHeight - o.taker.tradeHeight)*8000))

    let stat = stats['auction'][index];

    if(o.maker.sendsFromChain.toLowerCase() == 'nrg'){
      pairs['auction'][index].pastOrders.push(o)
    }
    else {
      if(stats['bid/ask'][index2]) index = index2;
      stat = stats['bid/ask'][index];
      pairs['bid/ask'][index].pastOrders.push(o)
    }

    if(new Date(stat.lastPrice.time) < o.timestamp) stat.lastPrice = {time: o.timestamp,price:o.price}
    if(new Date(stat.firstPrice.time) > o.timestamp) stat.firstPrice = {time: o.timestamp,price:o.price}

    if(!stat.low || stat.low > o.price) stat.low = o.price;
    if(!stat.high || stat.high < o.price) stat.high = o.price;

    stat.volume = new Decimal(stat.volume).add(new Decimal(o.price).mul(new Decimal(o.amount))).toString()

    return o;
  })
  return {newOrders,pairs,stats}
}


let cleanUpMyMatchedOrders = async (orders,state) => {
  let {pairs} = require('../../../config');
  let newPairs = JSON.parse(JSON.stringify(pairs))
  let newOrders = [];
  let pending = state.pending.transactions
  let transfers = state.pending.transfers;
  for(let o of orders){
    let divider = new Decimal(o.maker.collateralizedNrg).div((new Decimal(o.taker.collateralizedNrg).div(new Decimal(o.maker.base))));

    o.sendsAmount = o.isMaker ? new Decimal(o.maker.sendsUnit).div(divider).toNumber() : new Decimal(o.maker.receivesUnit).div(divider).toNumber();
    o.receivesAmount = !o.isMaker ? new Decimal(o.maker.sendsUnit).div(divider).toNumber() : new Decimal(o.maker.receivesUnit).div(divider).toNumber();
    o.sendsFromAddress = o.isMaker ? o.maker.sendsFromAddress : o.taker.sendsFromAddress;
    o.receivesToAddress = o.isMaker ? o.maker.receivesToAddress : o.taker.receivesToAddress;
    o.sendsToAddress = o.isMaker ? o.taker.receivesToAddress : o.maker.receivesToAddress;
    o.receivesFromAddress = o.isMaker ? o.taker.sendsFromAddress : o.maker.sendsFromAddress;
    o.sendsFromChain = o.isMaker ? o.maker.sendsFromChain.toUpperCase() : o.maker.receivesToChain.toUpperCase();
    o.receivesToChain = o.isMaker ? o.maker.receivesToChain.toUpperCase() : o.maker.sendsFromChain.toUpperCase();
    o.collateral = new Decimal(o.taker.collateralizedNrg).div(new Decimal(o.maker.base)).toNumber();
    o.yourStatus = o.isMaker ? o.maker.isSettled : o.taker.isSettled;
    o.theirStatus =  o.isMaker ? o.taker.isSettled : o.maker.isSettled;
    o.unlock = await unlockData(state.settings.settings,state.socket.latestBlock,o.maker)
    o.deadline = o.unlock.unlockText;
    if(o.unlock.bcLeft <= 0){
      if(o.unlock.makerLeft <= 0 && o.unlock.takerLeft <= 0){
        o.past = true;
      }
    }

    let unlock = transfers[`${o.taker.txHash}.${o.taker.txOutputIndex}`];
    o.unlocking = unlock && unlock.type === "Unlock Collateral";
    if(unlock && unlock.chain === o.sendsFromChain && !o.yourStatus) o.yourStatus = 'Sending';

    newOrders.push(o);
  }
  return newOrders;
}
